import { MutationTree } from 'vuex';
import { UserState } from '../types';

const mutations: MutationTree<UserState> = {
  setUser(state: UserState, profile: {displayName: string, photoURL: string}) {
    state.profile = {
      displayName: profile.displayName,
      photoUrl: profile.photoURL,
    };

    state.loggedIn = true;
  },
  clearUser(state: UserState) {
    state.profile = {};
    state.loggedIn = false;
  },
};

export default mutations;
